export const lines = {
  actions: {
    applyDiscount: 'Apply discount',
    duplicate: 'Copy',
    editProduct: 'Edit product',
    removeDiscount: 'Remove discount',
  },
  advantage: {
    buttonLabel: 'Check your benefit',
    label: 'Your benefit thanks to Creative Shelter',
  },
  benefit: 'Benefit',
  computerProgramAlert:
    'Invoicing a software assignment? Then select ‘Computer program service’. <faqLink>Want to know more about invoicing IT assignments?</faqLink>',
  creativeWork: {
    header: 'Type of service',
    options: {
      CreativeComputer: {
        description: 'You write software or code for your client.',
        label: 'Computer program service',
      },
      CreativeGeneral: {
        description: 'You create new, original work for your client.',
        label: 'Creative service',
      },
      CreativeReuse: {
        description: 'Your client reuses existing work of yours, or uses it for longer.',
        label: 'Reuse',
      },
      CreativeSubcontracting: {
        description: 'You re-invoice creative work that another freelancer did for you.',
        label: 'Subcontracting',
      },
      NonCreative: {
        description: 'You invoice costs such as materials, rent or travel.',
        label: 'Non-creative service',
      },
    },
    placeholder: 'Creative work?',
  },
  description: {
    header: 'Description',
    placeholder: 'Description',
    placeholderProduct: 'Extra information',
  },
  discount: {
    free: 'Free',
    header: 'Discount',
  },
  discountType: {
    flatRate: '€',
    percentage: '%',
  },
  lineTotal: {
    header: 'Total',
  },
  new: {
    invoiceLine: 'Add invoice line',
    photoAlbum: 'Add photo album',
    photoAlbumLine: 'Add photo album line',
    product: 'Add product',
    productTooltip:
      'Find out <a href="https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze" target="_blank">here</a> what products are!',
    quotationLine: 'Add quotation line',
    textLine: 'Add text line',
  },
  photoAlbum: {
    deleteDialog: {
      description: 'Are you sure you want to delete the ‘photo album’ section? This also deletes all lines in this section.',
      title: 'Delete photo album',
    },
    description: 'Add all invoice lines related to the photo album here.',
    tag: '6% VAT',
    tagTooltip: 'All lines under the photo album section are invoiced at 6% VAT.',
    title: 'Photo album',
  },
  price: {
    header: 'Price (excl. VAT)',
    productNotSyncTooltip: 'The price of your invoice line differs from your product price. Click here to use your product price.',
  },
  productName: {
    label: 'Product',
    tooltip: 'This line is based on a product. You can change it, but changes are only saved on your invoice, not in your product.',
  },
  quantity: {
    header: 'Quantity',
  },
  subtotal: 'Subtotal',
  textLine: 'Text line',
  total: 'Total',
  totalVat: 'Total VAT',
  units: {
    characters_one: 'Character',
    characters_other: 'Characters',
    days_one: 'Day',
    days_other: 'Days',
    halfDays_one: 'Half day',
    halfDays_other: 'Half days',
    hours_one: 'Hour',
    hours_other: 'Hours',
    kilometers: 'Km',
    none: '—',
    placeholder: 'Select',
    words_one: 'Word',
    words_other: 'Words',
  },
  vat: {
    header: 'VAT',
  },
  vatExported: 'Export',
  vatPercentage: 'VAT ({{ percentage }}%)',
  vatRegime: {
    exceptionallyExempt: 'VAT exempt',
    export: 'VAT export',
    shifted: 'VAT reverse-charged',
  },
  vatShifted: 'VAT reverse-charged',
  vatTooltip:
    'We always charge VAT on the invoice to your client, regardless of your VAT status, because Creative Shelter is a VAT-registered company. <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">Read more about it here!</a>',
};
